export default "__VITE_ASSET__104e2a05__"